export default { 
  HomeUser: require('./HomeUser').default,
  DetailUser: require('./DetailUser').default,
  Prakerja: require('./prakerja').default,
}